<template>
  <v-container>
    <v-card elevation="0" class="pt-5">
      <v-container>
        <v-row>
          <v-col md="2.5">
            <v-autocomplete
              v-model="teacher_id"
              outlined
              dense
              :items="teachers"
              :label="$t('search by name')"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-col>
          <v-col md="2.5">
            <v-autocomplete
              v-model="edu_class_id"
              outlined
              dense
              :items="eduClasses"
              :label="$t('search by educitional class')"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-col>
          <v-col md="2.5">
            <v-autocomplete
              v-model="subject_id"
              outlined
              dense
              :items="subjects"
              :label="$t('search by subject')"
              item-text="name"
              item-value="id"
            ></v-autocomplete>
          </v-col>
          <v-col md="2.5" class="d-flex justify-center align-center">
            <v-text-field
              v-model="title"
              :label="$t('search by title')"
              dense
              outlined
           
            ></v-text-field>
            <v-icon class="mr-2 mb-5" @click="fetchData(1)">mdi-magnify</v-icon>
          </v-col>
        </v-row>
      </v-container>

      <app-base-table
        :tableOptions="tableOptions"
        @re-fetch-data="fetchData"
        serverRoute="/lesson"
        @re-fetch-paginated-data="fetchData($event)"
        :enableDelete="displayDeleteIcon"
        :flaggedItems="flaggedItemsData"
      >
        <template slot="editFeature" slot-scope="{ row }">
          <v-icon
            color="green"
            @click="$router.push(`/view-teacher-lesson/${row.id}`)"
            >mdi-eye</v-icon
          >
          <app-edit-lesson-modal
            @recordUpdated="fetchData"
            :lesson="row"
          ></app-edit-lesson-modal>
        </template>
      </app-base-table>
    </v-card>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import editLessonModal from "./editLessonModal.vue";

export default {
  components: {
    appEditLessonModal: editLessonModal,
  },
  data() {
    return {
      edu_class_id: "",
      teacher_id: "",
      subject_id: "",
      day: "",
      title: "",
      order: "",
      dialog: false,
      submitBtnLoading: false,
      loading: false,
      flaggedItemsData: [],
    };
  },
  computed: {
    ...mapGetters({
      tableOptions: "lessons/getTableOptions",
      teachers: "teachers/getTeachers",
      subjects: "subjects/getSubjects",
      eduClasses: "educationClass/getEduClasses",
    }),
  },
  methods: {
    ...mapActions({
      fetchLessons: "lessons/fetchLessons",
      fetchTeachers: "teachers/fetchTeachers",
      fetchSubjects: "subjects/fetchSubjects",
      fetchAllEduClasses: "educationClass/fetchAllEduClasses",
    }),

    fetchData(page) {
      this.dialog = false;
      this.fetchTeachers({
        params: {
          page,
        },
      });
      this.fetchLessons({
        params: {
          page,
          edu_class_id: this.edu_class_id,
          teacher_id: this.teacher_id,
          subject_id: this.subject_id,
          day: this.day,
          order: this.order,
          title: this.title,
        },
      });
    },
  },
  created() {
    if (this.returnAbility("lesson:destroy")) {
      this.displayDeleteIcon = true;
    }
    this.fetchData(1);
    this.fetchTeachers();
    this.fetchSubjects();
    this.fetchAllEduClasses();
  },
};
</script>

<style></style>
